import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    label: { type: String, default: "Processando..." }
  }

  start() {
    const submitter = this.element.querySelector("button[type='submit'], input[type='submit']")
    if (!submitter) return

    submitter.disabled = true
    submitter.classList.add("disabled")

    if (submitter.tagName === "INPUT") {
      submitter.dataset.originalValue = submitter.value
      submitter.value = this.labelValue
    } else {
      submitter.dataset.originalText = submitter.textContent
      submitter.textContent = this.labelValue
    }
  }
}
